var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.24997C7.82209 9.68057 8.23302 10.0369 8.70491 10.2947C9.17681 10.5525 9.69863 10.7058 10.235 10.7442C10.7713 10.7826 11.3097 10.7052 11.8135 10.5173C12.3173 10.3294 12.7748 10.0353 13.155 9.65497L15.405 7.40497C16.0881 6.69772 16.4661 5.75046 16.4575 4.76722C16.449 3.78398 16.0546 2.84343 15.3593 2.14815C14.664 1.45287 13.7235 1.05849 12.7403 1.04995C11.757 1.0414 10.8098 1.41938 10.1025 2.10247L8.8125 3.38497",
    stroke: "#140B8E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4997 7.74992C10.1776 7.31933 9.76664 6.96304 9.29475 6.70522C8.82285 6.4474 8.30103 6.29409 7.76467 6.25567C7.22832 6.21726 6.68997 6.29465 6.18615 6.48259C5.68233 6.67053 5.22483 6.96462 4.84466 7.34492L2.59466 9.59492C1.91157 10.3022 1.53359 11.2494 1.54213 12.2327C1.55068 13.2159 1.94506 14.1565 2.64034 14.8517C3.33562 15.547 4.27617 15.9414 5.25941 15.95C6.24264 15.9585 7.1899 15.5805 7.89716 14.8974L9.17966 13.6149",
    stroke: "#140B8E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.90d820e1525d5b8d5f2006f138fffba6.svg";
export { ForwardRef as ReactComponent };